/*
 * Docs:
 * https://github.com/marmelab/react-admin/blob/master/docs/Admin.md#catchall
 * https://github.com/marmelab/react-admin/blob/master/docs/Admin.md#customroutes
 */
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import RemindPassword from './auth/RemindPassword';
import RemindPasswordConfirmation from './auth/RemindPasswordConfirmation';
import ProvideNewPassword from './auth/ProvideNewPassword';
import ComplianceDashboard from '../views/ComplianceDashboard';
import ComplianceDashboardSettings from '../views/ComplianceDashboardSettings';
import {DomainsCreate} from './domains/DomainsCreate';
import {AccountPage} from './account';
import SubscriptionManager from './account/subscription/SubscriptionManager';

export const RoutesWithoutAuth = [
  <Route exact path="/remindpassword" component={RemindPassword} noLayout/>,
  <Route
    path="/remindpassword/confirm"
    component={RemindPasswordConfirmation}
    noLayout
  />,
  <Route
    path="/newpassword/:passwordToken/:csrfToken"
    component={ProvideNewPassword}
    noLayout
  />,
];

export const RoutesBehindAuth = [
  <Route exact path="/domains/create/:websiteId" component={DomainsCreate}/>,
  <Route exact path="/compliance_dashboard" component={ComplianceDashboard}/>,
  <Route
    exact
    path="/compliance_dashboard_settings"
    component={ComplianceDashboardSettings}
  />,
  <Route exact path="/account" component={AccountPage}/>,
  <Route exact path="/subscription" component={SubscriptionManager}/>,
];

export const Routes = RoutesWithoutAuth.concat(RoutesBehindAuth);
